import './set-omni-ligne-mej-data';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@environments/environment';
import { AppConfig } from '@environments/AppConfig';

if ((environment as any).remote) {
  const fetchConfiguration = async (): Promise<AppConfig> => {
    const response = await fetch('assets/config.json');
    const config = await response.json();
    return config;
  };

  fetchConfiguration()
    .then((config: any) => {
      let env: any = environment;
      Object.keys(config).forEach((k: string) => {
        env[k] = config[k];
      });
      bootstrapApplication(AppComponent, appConfig)
        .then(() => console.log('Application started'))
        .catch((err) => console.error(err));
    })
    .catch((err) => console.error(err));
} else {
  bootstrapApplication(AppComponent, appConfig)
    .then(() => console.log('Application started'))
    .catch((err) => console.error(err));
}
